import React from 'react';

const GuestLayout = ({ children }) => {
    return (
        <div className="min-h-screen bg-stone-50 overflow-x-hidden min-w-0 relative">
            <div className="fixed inset-0 pointer-events-none">
                <div className="absolute inset-0 bg-gradient-to-b from-amber-100/30 via-transparent to-transparent" />
                <div className="absolute top-0 right-0 w-[80vmax] h-[80vmax] bg-amber-200/20 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2" />
                <div className="absolute bottom-0 left-0 w-[60vmax] h-[60vmax] bg-amber-100/25 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/2" />
            </div>
            <div className="relative min-h-screen">
                {children}
            </div>
        </div>
    );
};

export default GuestLayout;
